import classNames from "classnames";
import { Button } from "PFComponents/button";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useCustomValueCreateError } from "PFCore/hooks/queries/custom_fields/admin";
import { useCreateCustomValueByField } from "PFCore/hooks/queries/custom_fields/admin/use_custom_value_create/use_create_custom_value_by_field";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./custom_value.module.scss";

const AddNewContent = ({ id, handleRemoveItem, ordinal, className }) => {
  const { t } = useTranslation("translation");

  const [errors, setErrors] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const { parseCustomValueCreateError } = useCustomValueCreateError();

  const createCustomValue = useCreateCustomValueByField({
    onSuccess: () => handleRemoveItem(),
    onError: (err) => {
      parseCustomValueCreateError(err, (message) => {
        setErrors(message);
      });
    }
  });

  const isHierarchical = ordinal !== null;

  const handleSave = () => {
    createCustomValue.mutate({
      customTypeId: id,
      payload: { value: inputValue, ...(isHierarchical ? { ordinal } : {}) }
    });
  };

  return (
    <div className={classNames(css.inputRenderer, className)}>
      <span className={css.orderable} />
      <InputFieldSet
        className={css.inputValue}
        value={inputValue}
        qaId={`custom-field-dictionary`}
        error={errors}
        onChange={setInputValue}
      />
      <div className={css.lineButtons}>
        <Button kind="danger" small onClick={handleSave}>
          {t("save")}
        </Button>
        <Button small onClick={() => handleRemoveItem()}>
          {t("remove")}
        </Button>
      </div>
    </div>
  );
};

AddNewContent.propTypes = {
  id: PropTypes.number.isRequired,
  handleRemoveItem: PropTypes.func.isRequired,
  ordinal: PropTypes.number,
  className: PropTypes.string
};

export default AddNewContent;
